export const GET_UNIVERSITIES = 'GET_UNIVERSITIES';
